module.exports = __webpack_public_path__ + "static/media/wine-red.29fb8873.jpg";